module.exports = __webpack_public_path__ + "fonts/androidActive_60x60.7dc070b7a3dbbc324afeb7a3786f3020.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/androidActive_60x60.png
// module id = 744
// module chunks = 9